export default {
  apiKey: "AIzaSyDM0ja6yaucjhYYRqnjgmfye5YWGZkUUjM",
  authDomain: "pedenet-e1f0d.firebaseapp.com",
  projectId: "pedenet-e1f0d",
  storageBucket: "pedenet-e1f0d.appspot.com",
  messagingSenderId: "646220812351",
  appId: "1:646220812351:web:575b5d7ef0b420a5f3288a",
};
